import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { authApi } from "./api";
import logo from "../assets/images/logo_big.png";
import "./admin.css";
const PasswordInput = ({ value, onChange, placeholder = "••••••••", name }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        name={name}
        required
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
};

// ── Error banner ─────────────────────────────────────────────────────────────
const ErrorBanner = ({ msg }) =>
  msg ? <div className="error">{msg}</div> : null;

const AdminLogin = () => {
  const [view, setView] = useState("login");
  const [form, setForm] = useState({
    email: "",
    password: "",
    otp: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // After login, go back to the page they originally tried to visit
  const redirectTo = location.state?.from || "/admin/dashboard";

  const set = (field) => (e) => {
    setError("");
    setForm((f) => ({ ...f, [field]: e.target.value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token } = await authApi.login({
        email: form.email,
        password: form.password,
      });
      localStorage.setItem("hobAdminToken", token);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hoblogin-page">
      <div className="hoblogin-card">
        <div className="hoblogin-logo-wrap">
          <img src={logo} alt="Siro" className="hoblogin-logo" />
        </div>

        {success && <div className="hoblogin-success">{success}</div>}

        {view === "login" && (
          <>
            <h1 className="hoblogin-title">Admin Login</h1>

            <p className="hoblogin-subtitle">Sign in to manage HOB content</p>

            <form onSubmit={handleLogin} className="hoblogin-form">
              <div className="hoblogin-field">
                <label className="hoblogin-label">Email Address</label>

                <input
                  type="email"
                  required
                  value={form.email}
                  onChange={set("email")}
                  placeholder="hello@hob.com"
                  className="hoblogin-input"
                />
              </div>

              <div className="hoblogin-field">
                <label className="hoblogin-label">Password</label>

                <input
                  type="password"
                  required
                  value={form.password}
                  onChange={set("password")}
                  placeholder="xxxxx"
                  className="hoblogin-input"
                />
              </div>

              <ErrorBanner msg={error} />

              <div className="hoblogin-btn-wrap">
                <button
                  type="submit"
                  disabled={loading}
                  className="hoblogin-submit-btn"
                >
                  {loading ? "Signing In..." : "Sign In"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
